<div id="navbar-wrapper">
  <nav class="navbar navbar-inverse">
    <div class="navbar-container">
      <div class="navbar-header">
        <h1 class="navbar-title">{{ headerTitle }}</h1>
      </div>

      <div class="form-group mb-0 d-flex search mx-4">

        <div class="search-menu-text" (click)="openMenu()">
          @if(!selectedSearchMenu.default){
            <div class="k-icon k-i-close"> </div>
          }
          @else {
            <div class="k-font-icon k-i-arrow-60-down k-i-kpi-trend-decrease k-icon"></div>
          }

          <div> {{ selectedSearchMenu.text }}</div>
        </div>
        <div style="position: absolute;">
          <kendo-menu #kendoMenu [items]="menuOptions" (select)="onSelectMenu($event)" [openOnClick]="'click'"
                      [size]="'large'">
          </kendo-menu>
        </div>

        @if(autocompleteModel.data.length){
          <div (click)="autocomplete.toggle()" class="project-list-count">
            {{ autocompleteModel.data.length }}
          </div>
        }

        <div class="project-list-button">

          @if(projectList.selectedProject){
            <div (click)="clearSelectedProject();" class="k-icon k-i-close"> </div>
            <div (click)="onProjectListButtonClick()">{{ projectList.selectedProject.name }}</div>
          }
          @else {
            <div (click)="onProjectListButtonClick()" class="k-font-icon k-i-arrow-60-down k-i-kpi-trend-decrease k-icon">
            </div>
            <div (click)="onProjectListButtonClick()">{{ 'All projects' | translate }}</div>
          }

        </div>
        <div *ngIf="projectList.show" class="project-list-container">

          <div class="d-flex justify-content-between align-items-center p-2 w-100">
            <div class="project-list-search">
              <input name="searchValue" [(ngModel)]="projectList.searchValue" #searchInput autofocus="true"
                     (keyup.enter)="onProjectListSearch()" placeholder="{{ 'search' | translate }}" kendoTextBox
                     style="width: 260px;" />
              <button style="position: absolute;right: 15px;top: 2px;" (click)="onProjectListSearch()" kendoButton
                      type="button" class="btn" [icon]="'search'"></button>
            </div>
            <div (click)="projectList.show=false;" style="position: absolute;right: 10px;top: 5px;cursor: pointer;">
              <div class="k-icon k-i-close"> </div>
            </div>
          </div>

          <i *ngIf="projectList.loading" class="fa ml-2 mt-2 fa-spinner fa-spin"></i>

          <div class="project-list-content">
            <div *ngFor="let project of projectList.projects | filter: 'name':projectList.searchValue"
                 (click)="onProjectSelect(project)" class="list-item">
              <div> {{ project.name }}</div>
            </div>
          </div>

        </div>
        <span role="presentation" class="k-icon k-i-search"></span>
        <kendo-autocomplete #autocomplete (keydown)="onKeyDown($event)" [loading]="autocompleteModel.loading"
                            (filterChange)="handleSearch($event)" name="search" [(ngModel)]="autocompleteModel.value"
                            [(value)]="autocompleteModel.value" (valueChange)="locationAutoCompleteChanged($event)" [filterable]="true"
                            [valueField]="'value'" [data]="autocompleteModel.data" style="border-radius: 0 6px 6px 0 !important;">


          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'no data' | translate }}
          </ng-template>


          <ng-template kendoAutoCompleteItemTemplate let-dataItem>
            <div class="d-flex justify-content-between w-100">
              <span>{{ dataItem.value }}</span>

              <span (click)="openNewTab($event,dataItem)">
                <span role="presentation" class="k-icon k-i-hyperlink-open"></span>
              </span>
            </div>
          </ng-template>
        </kendo-autocomplete>
      </div>



      <div class="d-flex align-items-end">

        <div *ngIf="permissions.READ_CHAT" class="navbar-notification "
             [ngClass]="{ 'has-notify': unSeenMessagesNr > 0 }" [routerLink]="['/chat']">
          <img src="../../../../assets/images/chat.png" class="mr-2" width="37" />
          <i *ngIf="unSeenMessagesNr" style="top: -9px;right:-5px;">{{unSeenMessagesNr <=9? unSeenMessagesNr: '9+'}}</i>
        </div>
        <div title="{{ notificationsNr }}" class="navbar-notification" [ngClass]="{ 'has-notify': notificationsNr > 0 }"
             (click)="openNotificationsModal()">
          <span class="k-icon k-i-notification"></span>
          <i> {{ notificationsNr }}</i>
        </div>

        <div [ngClass]="{'mr-5': !permissions.READ_KNOWLEDGE_MANAGEMENT}" *ngIf="userAuth.extern !== 1 && active"
             class="d-flex align-items-end ">
          <div class="form-group hasValue m-0 isDisabled timeTrack">
            <label class="mr-2">Time Tracking</label>
            <input class="mnc-control" name="timeFormat" [(ngModel)]="timeTrackingViewModel.timeFormat"
                   style="height: 36px" readonly="" type="text" />
          </div>
          <ng-container *ngIf="!this.timeTrackingViewModel.isDayEnded">
            <div class="ml-3 text-center">
              <h1 *ngIf="timeTrackingViewModel.timeLine.currentEntry == null" class="startButtonText">
                {{'Start' | translate | uppercase}}
              </h1>
              <h1 *ngIf="timeTrackingViewModel.timeLine.currentEntry != null" class="startButtonText">
                {{ "End" | translate | uppercase }}
              </h1>

              <div *ngIf="timeTrackingViewModel.timeLine.currentEntry != null" (click)="onBtnEndTimeClick()"
                   class="stopButton">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="12" height="12" fill="white" />
                </svg>
              </div>

              <div *ngIf="timeTrackingViewModel.timeLine.currentEntry == null" (click)="onBtnStartTimeClick()"
                   [ngClass]="{ dayEnded: timeTrackingViewModel.isDayEnded }" class="startButton">
                <span class="k-icon k-i-arrow-60-right" role="presentation"></span>
              </div>
            </div>
            <div class="ml-3 text-center">
              <h1 class="startButtonText">
                {{ "Next" | translate | uppercase }}
              </h1>
              <div class="nextButton" [ngClass]="{
                  'bg-green': timeTrackingViewModel.projects.length % 2 == 1
                }" (click)="onBtnNextClick()">
                +
              </div>
            </div>
            <div class="ml-3 text-center">
              <h1 class="startButtonText">
                {{ "break" | translate | uppercase }}
              </h1>
              <div *ngIf="timeTrackingViewModel.timeLine.currentEntry != null && !timeTrackingViewModel.timeLine.isOnPause" class="breakButton"
                   [ngClass]="{ dayEnded: timeTrackingViewModel.isDayEnded }" (click)="onBtnStartPauseClick()">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.4444 0H0V7.77778C0 9.49667 1.39222 10.8889 3.11111 10.8889H7.77778C9.49667 10.8889 10.8889 9.49667 10.8889 7.77778V5.44444H12.4444C13.3078 5.44444 14 4.74444 14 3.88889V1.55556C14 0.692222 13.3078 0 12.4444 0ZM12.4444 3.88889H10.8889V1.55556H12.4444V3.88889ZM0 12.4444H12.4444V14H0V12.4444Z"
                    fill="white" />
                </svg>
              </div>

              <div *ngIf="timeTrackingViewModel.timeLine.currentEntry != null && timeTrackingViewModel.timeLine.isOnPause" class="breakButton-on"
                   [ngClass]="{ dayEnded: timeTrackingViewModel.isDayEnded }" (click)="onBtnResumeClick()">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.4444 0H0V7.77778C0 9.49667 1.39222 10.8889 3.11111 10.8889H7.77778C9.49667 10.8889 10.8889 9.49667 10.8889 7.77778V5.44444H12.4444C13.3078 5.44444 14 4.74444 14 3.88889V1.55556C14 0.692222 13.3078 0 12.4444 0ZM12.4444 3.88889H10.8889V1.55556H12.4444V3.88889ZM0 12.4444H12.4444V14H0V12.4444Z"
                    fill="white" />
                </svg>
              </div>

              <div *ngIf="timeTrackingViewModel.timeLine.currentEntry == null" class="breakButton"
                   style="opacity: 0.4; cursor: not-allowed;">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.4444 0H0V7.77778C0 9.49667 1.39222 10.8889 3.11111 10.8889H7.77778C9.49667 10.8889 10.8889 9.49667 10.8889 7.77778V5.44444H12.4444C13.3078 5.44444 14 4.74444 14 3.88889V1.55556C14 0.692222 13.3078 0 12.4444 0ZM12.4444 3.88889H10.8889V1.55556H12.4444V3.88889ZM0 12.4444H12.4444V14H0V12.4444Z"
                    fill="white" />
                </svg>
              </div>
            </div>
          </ng-container>
        </div>
        <div *ngIf="permissions.READ_KNOWLEDGE_MANAGEMENT" class="form-group hasValue ml-4 m-0 isDisabled timeTrack">
          <h1 class="ml-1 startButtonText">{{'Hilfe' | translate | uppercase}}</h1>
          <div (click)="openHelpPage()" class="stopButton  mr-5 kmsButton">
            <img class="cursor-pointer" src="assets/images/icons/question-mark-kn.svg" />
          </div>
        </div>


        <ul class="navbar-nav">
          <li class="nav-item dropdown" (click)="onUserInfoClick()">
            <a class="nav-link" style="
                padding-left: 20px !important;
                padding-right: 20px !important;
                padding-top: 0px;
                padding-bottom: 0px;
              " href="javascript:void(0)">
              <span style="
                  font-size: 14px;
                  color: #fff;
                  margin-top: 0px;
                  display: block;
                ">{{ userAuth.name }} {{ userAuth.surname }}</span>
            </a>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link" style="padding-right: 0px !important" (click)="logOut()" href="javascript:void(0)"
               id="navbarDropdownProfile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span style="font-size: 16px; color: #fff" class="k-icon k-i-logout"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownProfile">
              <a class="dropdown-item" href="#">Profile</a>
              <a class="dropdown-item" href="#">Settings</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="logOut()">Log out</a>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="breadcrumbs-container">
      <ul class="breadcrumb">
        <li *ngFor="let item of breadcrumbs" (click)="onClickBreadCrumb(item)" class="breadcrumb-item">
          <a class="cursor-pointer">{{ item.name }}</a>
        </li>
      </ul>

      <div class="d-flex">
        <div *ngIf="onSaving" class="d-flex align-items-center mr-3">
          <div>
            <i style="font-size: 16px" class="fa fa-spinner fa-spin"></i>
          </div>
          <h5 style="
            font-size: 14px;
            margin-bottom: 0px;
            margin-top: 6px;
            margin-left: 10px;
          ">
            bearbeite Anfrage...
          </h5>
        </div>

        <div *ngIf="showAnotherTabOpen()" class="tab-warning">
          <span class="icon"><img width="18px" height="18px" src="../../../../assets/images/info.png" alt="info"></span>
          {{'This location is active in another tab under your user session.' | translate}}
        </div>

      </div>
    </div>
  </nav>
</div>

<kendo-dialog title="{{ 'End' | translate }}" *ngIf="dialogs.endTime" (close)="closeEndTime()" [width]="1100">
  <div class="modal-body">
    <form #endTimeForm="ngForm">
      <div class="form-row align-items-center justify-content-between">
        <div class="form-group col-md-4 hasValue" [ngClass]="{ isDisabled: !timeTrackingViewModel.timeLine.change }"
             [class.has-error]="
            endTimePicker.invalid &&
            (endTimePicker.dirty || endTimePicker.touched)
          ">
          <label>{{ "End" | translate }} *</label>

          <kendo-timepicker format="HH:mm" name="endTime" [disabled]="!timeTrackingViewModel.timeLine.change"
                            [(ngModel)]="timeTrackingViewModel.timeLine.endTime" #endTimePicker="ngModel" required
                            [(value)]="timeTrackingViewModel.timeLine.endTime" (valueChange)="timePickerChanged()">
            <kendo-datetimepicker-messages today="{{ 'today' | translate }}" dateTab="Datum" timeTab="Zeit"
                                           now="{{ 'now' | translate }}" cancel="{{ 'cancel' | translate }}" accept="{{ 'set' | translate }}">
            </kendo-datetimepicker-messages>
          </kendo-timepicker>
        </div>
        <div class="form-group col-md-2 checkbox-group">
          <input type="checkbox" name="change" kendoCheckBox [(ngModel)]="timeTrackingViewModel.timeLine.change" />
          <label>{{ "Endzeit ändern" | translate }}</label>
        </div>
        <div class="form-group col-md-4 hasValue isDisabled">
          <label>{{ "Total" | translate }}</label>
          <span style="top: 13px; position: absolute; left: 18px">{{
              timeTrackingViewModel.summary.timeWorked
            }}</span>
          <input type="text" placeholder="" autocomplete="new-endetComment" disabled class="mnc-control" ngModel
                 name="pause-endetComment" />
        </div>

      </div>
      <div class="form-row align-items-start">
        <div *ngIf="timeTrackingViewModel.timeLine.change" class="form-group col-md-12" [class.has-error]="
            endetComment.invalid && (endetComment.dirty || endetComment.touched)
          ">
          <label>{{ "note" | translate }} *</label>
          <textarea autocomplete="new-endetComment" style="height: 100px !important; resize: none;" required
                    [(ngModel)]="timeTrackingViewModel.timeLine.endetComment" class="mnc-control" ngModel name="comment"
                    #endetComment="ngModel">
          </textarea>
        </div>
      </div>
      <div  class="mt-4">
        <div class="form-row align-items-end  justify-content-between">
          <div class="form-group mb-2 col-md-6" style="border-bottom: 1px solid #c3c3c3"
               [ngClass]="{ isDisabled: !timeTrackingViewModel.timeLine.change }">
            <h6 style="font-weight: 600">{{ "Projektmanagement - Normal Hours" | translate }}</h6>
          </div>

          <div class="form-group mb-2 col-md-3 hasValue isDisabled has-error">
            <label>{{ "Remain" | translate }}</label>
            <span style="top: 13px; position: absolute; left: 18px">{{
                timeTrackingViewModel.summary.timeRemainProjects
              }}</span>
            <input type="text" [ngClass]="{ red: !timeTrackingViewModel.summary.isValid }" placeholder=""
                   autocomplete="new-endetComment" disabled class="mnc-control" ngModel name="pause-endetComment" />
          </div>

          <div class="form-group mb-2 mw-6 hasValue">
            <button (click)="timeTrackingViewModel.addProjectLine()" type="button" class="plus mx-auto">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div *ngFor="let item of getDayProjects(); let z = index"
             class="form-row align-items-end my-3 justify-content-between">
          <div class="form-group mb-2 col-md-6 hasValue" [class.has-error]="item.project == null">
            <kendo-dropdownlist ngModel [kendoDropDownFilter]="filterSettings" [filterable]="true"
                                [(ngModel)]="item.project" name="manager-{{ z }}" [(value)]="item.project" [textField]="'nrAndName'"
                                [valueField]="'nrAndName'" required [data]="timeTrackingViewModel.collectionViewModel.projects">
            </kendo-dropdownlist>
          </div>
          <div class="form-group mb-2 col-md-3 hasValue" [class.has-error]="item.time == null">
            <kendo-timepicker name="item-endTime-{{ z }}" [format]="'HH:mm'" (valueChange)="timePickerChanged(true)"
                              [(ngModel)]="item.time" #endTimePicker="ngModel" required [(value)]="item.time">
              <kendo-datetimepicker-messages today="{{ 'today' | translate }}" dateTab="Datum" timeTab="Zeit"
                                             now="{{ 'now' | translate }}" cancel="{{ 'cancel' | translate }}" accept="{{ 'set' | translate }}">
              </kendo-datetimepicker-messages>
            </kendo-timepicker>
          </div>
          <div class="form-group mb-2 mw-6 hasValue">
            <button (click)="timeTrackingViewModel.deleteProjectLine(item)" class="remove mx-auto" type="button">
              <i aria-hidden="true" class="fa fa-minus"></i>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="timeTrackingViewModel.timeLine.includeNightDuration" class="mt-4">
        <div class="form-row align-items-end mb-3 justify-content-between">
          <div class="form-group mb-2 col-md-6" style="border-bottom: 1px solid #c3c3c3"
               [ngClass]="{ isDisabled: !timeTrackingViewModel.timeLine.change }">
            <h6 style="font-weight: 600">{{ "Projektmanagement - Night Hours" | translate }}</h6>
          </div>

          <div class="form-group mb-2 col-md-3 hasValue isDisabled has-error">
            <label>{{ "Remain" | translate }}</label>
            <span style="top: 13px; position: absolute; left: 18px">{{
                timeTrackingViewModel.summary.timeRemainNightProjects
              }}</span>
            <input type="text" [ngClass]="{ red: !timeTrackingViewModel.summary.isNightValid }" placeholder=""
                   autocomplete="new-endetComment" disabled class="mnc-control" ngModel name="pause-endetComment" />
          </div>

          <div class="form-group mb-2 mw-6 hasValue">
            <button (click)="timeTrackingViewModel.addProjectLine(0, true)" type="button" class="plus mx-auto">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div *ngFor="let item of getNightProjects(); let z = index"
             class="form-row align-items-end  my-3 justify-content-between">
          <div class="form-group mb-2 col-md-6 d-flex hasValue" [class.has-error]="item.project == null">
            <kendo-dropdownlist ngModel [kendoDropDownFilter]="filterSettings" [filterable]="true"
                                [(ngModel)]="item.project" name="manager-night-{{ z }}" [(value)]="item.project" [textField]="'nrAndName'"
                                [valueField]="'nrAndName'" required [data]="timeTrackingViewModel.collectionViewModel.projects">
            </kendo-dropdownlist>
            <input type="text"  [(ngModel)]="item.additionalDuration"  disabled class="mnc-control ml-2" ngModel name="additionalDuration-night-{{ z }}"  />
          </div>
          <div class="form-group mb-2 col-md-3 hasValue" [class.has-error]="item.time == null">
            <kendo-timepicker name="item-endTime-night-{{ z }}" [format]="'HH:mm'" (valueChange)="timePickerChanged(true, item)"
                              [(ngModel)]="item.time" #endTimePicker="ngModel" required [(value)]="item.time">
              <kendo-datetimepicker-messages today="{{ 'today' | translate }}" dateTab="Datum" timeTab="Zeit"
                                             now="{{ 'now' | translate }}" cancel="{{ 'cancel' | translate }}" accept="{{ 'set' | translate }}">
              </kendo-datetimepicker-messages>
            </kendo-timepicker>
          </div>
          <div class="form-group mb-2 mw-6 hasValue">
            <button (click)="timeTrackingViewModel.deleteProjectLine(item)" class="remove mx-auto" type="button">
              <i aria-hidden="true" class="fa fa-minus"></i>
            </button>
          </div>
        </div>
      </div>
      <div  *ngIf="timeTrackingViewModel.timeLine.includeSundayDuration" class="mt-4">
        <div class="form-row align-items-end mb-3 justify-content-between">
          <div class="form-group mb-2 col-md-6" style="border-bottom: 1px solid #c3c3c3"
               [ngClass]="{ isDisabled: !timeTrackingViewModel.timeLine.change }">
            <h6 style="font-weight: 600">{{ "Projektmanagement - Sunday Hours" | translate }}</h6>
          </div>

          <div class="form-group mb-2 col-md-3 hasValue isDisabled has-error">
            <label>{{ "Remain" | translate }}</label>
            <span style="top: 13px; position: absolute; left: 18px">{{
                timeTrackingViewModel.summary.timeRemainSundayProjects
              }}</span>
            <input type="text" [ngClass]="{ red: !timeTrackingViewModel.summary.isSundayValid }" placeholder=""
                   autocomplete="new-endetComment" disabled class="mnc-control" ngModel name="pause-endetComment" />
          </div>

          <div class="form-group mb-2 mw-6 hasValue">
            <button (click)="timeTrackingViewModel.addProjectLine(0, false,true)" type="button" class="plus mx-auto">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div *ngFor="let item of getSundayProjects(); let z = index"
             class="form-row align-items-end  my-3 justify-content-between">
          <div class="form-group mb-2 d-flex col-md-6 hasValue" [class.has-error]="item.project == null">
            <kendo-dropdownlist ngModel [kendoDropDownFilter]="filterSettings" [filterable]="true"
                                [(ngModel)]="item.project" name="manager-sunday-{{ z }}" [(value)]="item.project" [textField]="'nrAndName'"
                                [valueField]="'nrAndName'" required [data]="timeTrackingViewModel.collectionViewModel.projects">
            </kendo-dropdownlist>
            <input type="text"  [(ngModel)]="item.additionalDuration"  disabled class="mnc-control ml-2" ngModel name="additionalDuration-night-{{ z }}"  />
          </div>
          <div class="form-group mb-2 col-md-3 hasValue" [class.has-error]="item.time == null">
            <kendo-timepicker name="item-endTime-sunday-{{ z }}" [format]="'HH:mm'" (valueChange)="timePickerChanged(true, item)"
                              [(ngModel)]="item.time" #endTimePicker="ngModel" required [(value)]="item.time">
              <kendo-datetimepicker-messages today="{{ 'today' | translate }}" dateTab="Datum" timeTab="Zeit"
                                             now="{{ 'now' | translate }}" cancel="{{ 'cancel' | translate }}" accept="{{ 'set' | translate }}">
              </kendo-datetimepicker-messages>
            </kendo-timepicker>
          </div>
          <div class="form-group mb-2 mw-6 hasValue">
            <button (click)="timeTrackingViewModel.deleteProjectLine(item)" class="remove mx-auto" type="button">
              <i aria-hidden="true" class="fa fa-minus"></i>
            </button>
          </div>
        </div>
      </div>

      <div>
        <div class="form-row align-items-end mb-3 mt-4 justify-content-between">
          <div class="form-group mb-2 col-md-6" style="border-bottom: 1px solid #c3c3c3"
               [ngClass]="{ isDisabled: !timeTrackingViewModel.timeLine.change }">
            <h6 style="font-weight: 600">
              {{ "breaks" | translate | titlecase }}
            </h6>
          </div>

          <div class="form-group mb-2 col-md-3 hasValue isDisabled">
            <span style="top: 13px; position: absolute; left: 54px">{{
                timeTrackingViewModel.summary.timePauses
              }}</span>
            <input type="text" placeholder="" autocomplete="new-endetComment" disabled class="mnc-control" ngModel
                   name="pause-endetComment" />
          </div>
          <div class="form-group mb-2 mw-6 hasValue">
            <button (click)="timeTrackingViewModel.addBreakLine()" type="button" class="plus pause mx-auto">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div *ngFor="
            let item of timeTrackingViewModel.pauseTimeLines;
            let z = index
          " class="form-row align-items-end justify-content-between pause-items">
          <div class="form-group mb-2 col-md-2 hasValue" [class.has-error]="item.startTime == null || errorPause">
            <kendo-timepicker [name]="'pause-startTime-'+z" [format]="'HH:mm'"
                              (valueChange)="timePickerPauseChanged(z, true)" [(ngModel)]="item.startTime" #startTimePicker="ngModel"
                              required [(value)]="item.startTime">
              <kendo-datetimepicker-messages today="{{ 'today' | translate }}" dateTab="Datum" timeTab="Zeit"
                                             now="{{ 'now' | translate }}" cancel="{{ 'cancel' | translate }}" accept="{{ 'set' | translate }}">
              </kendo-datetimepicker-messages>
            </kendo-timepicker>
          </div>
          <div class="form-group mb-2 col-md-2 hasValue" [class.has-error]="item.endTime == null|| errorPause">
            <kendo-timepicker [name]="'pause-endTime-'+z" [format]="'HH:mm'" (valueChange)="timePickerPauseChanged(z)"
                              [(ngModel)]="item.endTime" #endTimePicker="ngModel" required [(value)]="item.endTime">
              <kendo-datetimepicker-messages today="{{ 'today' | translate }}" dateTab="Datum" timeTab="Zeit"
                                             now="{{ 'now' | translate }}" cancel="{{ 'cancel' | translate }}" accept="{{ 'set' | translate }}">
              </kendo-datetimepicker-messages>
            </kendo-timepicker>
          </div>
          <div style="margin-left: 65px;" class="form-group mb-2 col-md-3 hasValue">
            <input type="text" [(ngModel)]="item.startedComment" placeholder="{{ 'comment' | translate }}"
                   autocomplete="new-endetComment-{{ z }}" class="mnc-control" ngModel name="pause-endetComment-{{ z }}" />
          </div>
          <div class="form-group mb-2 mw-6 hasValue">
            <button (click)="deletePauseLine(item, z)" class="remove mx-auto" type="button">
              <i aria-hidden="true" class="fa fa-minus"></i>
            </button>
          </div>
        </div>
        <div class="d-flex flex-column mt-3 w-50">
          <div *ngIf="timeTrackingViewModel.timeLine.showNightShiftQuestion && timeTrackingViewModel.timeLine.isVactionFromCalendar?.type !== 'Gesetzlicher Feiertag'"
               class="d-flex justify-content-between align-items-center">
            <span>
              {{
                "the start time/end time is outside of the daily working hours, if this was ordered by your supervisor"
                  | translate
              }}?
            </span>
            <div>
              <input [(ngModel)]="
                  timeTrackingViewModel.timeLine.includeNightDuration
                " (change)="onSupervisorNightToggle()" class="k-checkbox p-3" name="mwkw" type="checkbox" />
            </div>
          </div>
          <div *ngIf="timeTrackingViewModel.timeLine.showSundayShiftQuestion" [ngClass]="{
              'mt-2': timeTrackingViewModel.timeLine.showNightShiftQuestion && timeTrackingViewModel.timeLine.isVactionFromCalendar?.type !== 'Gesetzlicher Feiertag'
            }" class="d-flex justify-content-between align-items-center">
            <span>
              {{
                "The working time is on a Sunday or public holiday if this has been ordered by your supervisor"
                  | translate
              }}?
            </span>
            <div>
              <input [(ngModel)]="
                  timeTrackingViewModel.timeLine.includeSundayDuration
                " name="includeSundayDuration" (change)="onSupervisorSundayToggle()" class="k-checkbox p-3" type="checkbox" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer mt-4">
    <button class="btn-save" [disabled]="
        !endTimeForm.valid || !timeTrackingViewModel.summary.isSundayValid || onSaving || !timeTrackingViewModel.summary.isValid || errorPause || !timeTrackingViewModel.summary.isNightValid
      " (click)="endTime()" kendoButton primary="true">
      <i *ngIf="onSaving" class="fa fa-spinner fa-spin"></i>
      {{ "save" | translate }}
    </button>
    <button kendoButton (click)="closeEndTime()" type="button" class="btn-cancel">
      {{ "conclude" | translate }}
    </button>
  </div>
</kendo-dialog>

<kendo-dialog title="{{ 'Start' | translate }}" *ngIf="dialogs.startTime" (close)="dialogs.startTime = false"
              [width]="700">
  <div class="modal-body">
    <form #startTimeForm="ngForm">
      <div class="form-row align-items-end">
        <div class="form-group col-md-12" [ngClass]="{ isDisabled: !timeTrackingViewModel.timeLine.change }"
             [class.has-error]="
            startTimePicker.invalid &&
            (startTimePicker.dirty || startTimePicker.touched)
          ">
          <label>{{ "Start" | translate }} *</label>

          <kendo-timepicker format="HH:mm" name="startTime" [disabled]="!timeTrackingViewModel.timeLine.change"
                            [(ngModel)]="timeTrackingViewModel.timeLine.startTime" #startTimePicker="ngModel" required
                            [(value)]="timeTrackingViewModel.timeLine.startTime">
            <kendo-datetimepicker-messages today="{{ 'today' | translate }}" dateTab="Datum" timeTab="Zeit"
                                           now="{{ 'now' | translate }}" cancel="{{ 'cancel' | translate }}" accept="{{ 'set' | translate }}">
            </kendo-datetimepicker-messages>
          </kendo-timepicker>
        </div>
      </div>
      <div class="form-row align-items-start">
        <div class="form-group col-auto checkbox-group">
          <input type="checkbox" name="change" kendoCheckBox [(ngModel)]="timeTrackingViewModel.timeLine.change" />
          <label>{{ "Startzeit ändern" | translate }}</label>
        </div>
        <div *ngIf="timeTrackingViewModel.timeLine.change" class="form-group col-md-8" [class.has-error]="
            startedComment.invalid &&
            (startedComment.dirty || startedComment.touched)
          ">
          <label>{{ "note" | translate }} *</label>
          <textarea autocomplete="new-startedComment" style="height: 100px !important" required
                    [(ngModel)]="timeTrackingViewModel.timeLine.startedComment" class="mnc-control" ngModel name="comment"
                    #startedComment="ngModel">
          </textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn-save" [disabled]="!startTimeForm.valid || onSaving" (click)="startTime()" kendoButton
            primary="true">
      <i *ngIf="onSaving" class="fa fa-spinner fa-spin"></i>
      {{ "save" | translate }}
    </button>
    <button kendoButton (click)="dialogs.startTime = false" type="button" class="btn-cancel">
      {{ "conclude" | translate }}
    </button>
  </div>
</kendo-dialog>
<kendo-dialog id="travel-time-dialog" title="{{ 'Travel' | translate }}"
              *ngIf="dialogs.travelTime || dialogs.travelTimeEnd" [width]="700">
  <div class="modal-body">
    <form #travelTimeForm="ngForm">
      <div class="form-row">
        <div class="form-group d-flex col-md-12 hasValue mb-4">
          <div class="d-flex w-100">
            <img
              *ngIf="timeTrackingViewModel?.timeLine?.transportType == 'driving' || timeTrackingViewModel?.timeLine?.transportTypeMode?.id == 'driving'"
              class="travel-time-transport-icon" src="../../../../../../assets/images/icons/car.svg" alt="" width="35px"
              srcset="" />
            <img
              *ngIf="timeTrackingViewModel?.timeLine?.transportType == 'transit' || timeTrackingViewModel?.timeLine?.transportTypeMode?.id == 'transit'"
              class="travel-time-transport-icon" src="../../../../../../assets/images/icons/bus.svg" alt="" width="35px"
              srcset="" />
            <div class="w-100">
              <label>{{'office2'|translate}}</label>
              <input type="text"
                     *ngIf="!timeTrackingViewModel.timeLine.startFromAnotherOffice && !timeTrackingViewModel.timeLine.endFromAnotherOffice"
                     [value]="('From Your Home to Your Office' | translate) + ' '+ getTimeFormated(timeTrackingViewModel.timeLine.travelToOfficeDuration, true)"
                     class="travel-time-modal-input form-control" name="office2" required disabled>

              <input type="text" *ngIf="timeTrackingViewModel.timeLine.startFromAnotherOffice"
                     [value]="('Von der Betriebsstätte ' | translate) + timeTrackingViewModel.timeLine.ownOffice+  ' zur Betriebsstätte '+ timeTrackingViewModel.timeLine.startFromAnotherOffice + ' '+ getTimeFormated(timeTrackingViewModel.timeLine.travelToOfficeDuration, true)"
                     class="form-control" name="office2" required disabled>
              <input type="text" *ngIf="timeTrackingViewModel.timeLine.endFromAnotherOffice"
                     [value]="('Von der Betriebsstätte ' | translate) + timeTrackingViewModel.timeLine.endFromAnotherOffice +  ' zur Betriebsstätte '+  timeTrackingViewModel.timeLine.ownOffice+ ' '+ getTimeFormated(timeTrackingViewModel.timeLine.travelToOfficeDuration, true)"
                     class="form-control" name="office2" required disabled>
            </div>
            <button (click)="findLocation('office','start')" type="button" class="btn btn-open m-0 px-2 mr-1">
              <span class="k-icon k-i-marker-pin-target"></span>
            </button>
          </div>
        </div>
        <div class="form-group d-flex col-md-12 hasValue mb-4">
          <div class="d-flex w-100">
            <img
              *ngIf="timeTrackingViewModel?.timeLine?.transportType == 'driving' || timeTrackingViewModel?.timeLine?.transportTypeMode?.id == 'driving'"
              class="travel-time-transport-icon" src="../../../../../../assets/images/icons/car.svg" alt="" width="35px"
              srcset="" />
            <img
              *ngIf="timeTrackingViewModel?.timeLine?.transportType == 'transit' || timeTrackingViewModel?.timeLine?.transportTypeMode?.id == 'transit'"
              class="travel-time-transport-icon" src="../../../../../../assets/images/icons/bus.svg" alt="" width="35px"
              srcset="" />
            <div class="w-100">
              <label>{{'Baustelle/Betriebsstätte'|translate}}</label>
              <input
                *ngIf="!timeTrackingViewModel.timeLine.startFromAnotherOffice && !timeTrackingViewModel.timeLine.endFromAnotherOffice"
                type="text"
                [value]="('From Your Home to Your Construction' | translate) + ' '+ getTimeFormated(timeTrackingViewModel.timeLine.travelToConstructionDuration, true)"
                class="form-control" name="construction" required disabled>
              <input *ngIf="timeTrackingViewModel.timeLine.startFromAnotherOffice" type="text"
                     [value]="('Vom Wohnort zur Betriebsstätte' | translate) + ' '+ timeTrackingViewModel.timeLine.startFromAnotherOffice + ' '+ getTimeFormated(timeTrackingViewModel.timeLine.travelToConstructionDuration, true)"
                     class="form-control" name="construction" required disabled>
              <input *ngIf="timeTrackingViewModel.timeLine.endFromAnotherOffice" type="text"
                     [value]="('Von der Betriebsstätte' | translate) + ' '+ timeTrackingViewModel.timeLine.endFromAnotherOffice + ' zum Wohnort '+ getTimeFormated(timeTrackingViewModel.timeLine.travelToConstructionDuration, true)"
                     class="form-control" name="construction" required disabled>
            </div>
            <button (click)="findLocation('home','end')" type="button" class="btn btn-open m-0 px-2 mr-1">
              <span class="k-icon k-i-marker-pin-target"></span>
            </button>
          </div>
        </div>
        <div class="form-group col-md-12 hasValue mb-4">
          <label>{{'Travel'|translate}}</label>
          <input type="text"
                 [value]="('Travel' | translate) + ' '+ getTimeFormated(timeTrackingViewModel.timeLine.durationDifference, true)"
                 class="form-control" name="Travel" required disabled>
        </div>
        <div *ngIf="timeTrackingViewModel.timeLine.durationDifference != 0" class="col-md-12">
          <h5>{{"Assign travel time to a project" | translate}}</h5>
          <div class="form-group mb-2  hasValue mt-4"
               [class.has-error]="timeTrackingViewModel.timeLine.project == null">
            <label>{{'project'|translate}}</label>
            <kendo-dropdownlist #project="ngModel" [kendoDropDownFilter]="filterSettings" [filterable]="true"
                                [(ngModel)]="timeTrackingViewModel.timeLine.project" name="project"
                                [(value)]="timeTrackingViewModel.timeLine.project" [textField]="'nrAndName'" [valueField]="'nrAndName'"
                                required [data]="timeTrackingViewModel.collectionViewModel.projects">
            </kendo-dropdownlist>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer mt-4">
    <button *ngIf="dialogs.travelTime" class="btn-save " [disabled]="!travelTimeForm.valid || onSaving"
            (click)="startTime(true)" kendoButton primary="true">
      <i *ngIf="onSaving" class="fa fa-spinner fa-spin"></i>
      {{ "save" | translate }}
    </button>
    <button *ngIf="dialogs.travelTimeEnd" class="btn-save " [disabled]="!travelTimeForm.valid || onSaving"
            (click)="endTime(true)" kendoButton primary="true">
      <i *ngIf="onSaving" class="fa fa-spinner fa-spin"></i>
      {{ "save" | translate }}
    </button>
    <!-- <button kendoButton (click)="dialogs.startTime = false" type="button" class="btn-cancel">
      {{ "conclude" | translate }}
    </button> -->
  </div>
</kendo-dialog>
<kendo-dialog id="travel-time-dialog" title="{{ 'Choose Transport Type' | translate }}"
              *ngIf="dialogs.transportTypeStart || dialogs.transportTypeEnd" [width]="700">
  <div class="modal-body">
    <form #travelModeForm="ngForm">
      <div class="form-row">
        <div class="col-md-12 transport-type-message d-flex">
          <img class="mx-2" src="../../../../../../assets/images/icons/info.svg" alt="" width="30px" srcset="" />
          <p class="m-0">
            {{ "You're working from another office today! We'll calculate your travel time based on the transport type you pick" | translate }}.
          </p>
        </div>
        <div class="col-md-12">
          <div class="form-row my-4">
            <div class="col-md-6 py-4">
              <div class="d-flex  align-items-center" style="flex-direction:column;">
                <button (click)="transportDrivingSelected()"
                        [ngClass]="{ 'travel-mode-btn-active': transportDrivingModeSelected }"
                        class="card-location-device-type d-flex me-1 p-2 py-4 w-50 travel-mode-btn justify-content-center">
                  <img *ngIf="!transportDrivingModeSelected" src="../../../../../../assets/images/icons/car.svg" alt=""
                       width="80px" srcset="" />
                  <img *ngIf="transportDrivingModeSelected" src="../../../../../../assets/images/icons/car_white.svg"
                       alt="" width="80px" srcset="" />
                  <span class="transport-type-start-progress-bar"></span>
                </button>
                <div class="loading-bar-container w-50">
                  <div class="loading-bar" [style.width.%]="loadingDrivingWidth" role="progressbar"
                       [attr.aria-valuenow]="loadingDrivingWidth" aria-valuemin="0" aria-valuemax="100">
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center w-50">
                  <h5 class="m-0 mt-2">
                    {{ ("Fahrzeug" | translate | uppercase) }}
                  </h5>
                </div>
              </div>
            </div>

            <div class="col-md-6 py-4">
              <div class="d-flex  align-items-center" style="flex-direction:column;">
                <button (click)="transportBusSelected()"
                        [ngClass]="{ 'travel-mode-btn-active': transportBusModeSelected }"
                        class="card-location-device-type d-flex me-1 p-2 py-4 w-50 travel-mode-btn justify-content-center">
                  <img *ngIf="!transportBusModeSelected" src="../../../../../../assets/images/icons/bus.svg" alt=""
                       width="80px" srcset="" />
                  <img *ngIf="transportBusModeSelected" src="../../../../../../assets/images/icons/bus_white.svg" alt=""
                       width="80px" srcset="" />
                </button>
                <div class="loading-bar-container w-50">
                  <div class="loading-bar" [style.width.%]="loadingBusWidth" role="progressbar"
                       [attr.aria-valuenow]="loadingBusWidth" aria-valuemin="0" aria-valuemax="100">
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center w-50">
                  <h5 class="m-0 mt-2" style="text-align: center;">
                    {{ ("Öffentliche Verkehrsmittel" | translate | uppercase) }}
                  </h5>
                </div>
              </div>
            </div>

          </div>

          <!-- <div class="form-group mb-2  hasValue mt-4"
            [class.has-error]="timeTrackingViewModel.timeLine.transportTypeMode == null">
            <label>{{'Transport Type'|translate}}</label>
            <kendo-dropdownlist required #transportTypeMode="ngModel"
              [(ngModel)]="timeTrackingViewModel.timeLine.transportTypeMode" name="transportTypeMode"
              [(value)]="timeTrackingViewModel.timeLine.transportTypeMode" [textField]="'name'" [valueField]="'id'"
              required [data]="timeTrackingViewModel.collectionViewModel.transportTypes">
            </kendo-dropdownlist>
          </div> -->
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer mt-4">
    <!-- <button *ngIf="dialogs.transportTypeStart" class="btn-save" [disabled]="!travelModeForm.valid || onSaving"
      (click)="startTime(false, true)" kendoButton primary="true">
      <i *ngIf="onSaving" class="fa fa-spinner fa-spin"></i>
      {{ "save" | translate }}
    </button>
    <button *ngIf="dialogs.transportTypeEnd" class="btn-save " [disabled]="!travelModeForm.valid || onSaving"
      (click)="endTime(false, true)" kendoButton primary="true">
      <i *ngIf="onSaving" class="fa fa-spinner fa-spin"></i>
      {{ "save" | translate }}
    </button> -->

    <!-- <button kendoButton (click)="dialogs.startTime = false" type="button" class="btn-cancel">
      {{ "conclude" | translate }}
    </button> -->
  </div>
</kendo-dialog>
<div *ngIf="usersOnThisPage.length > 0 && userAuth.id == 1" class="presence-indicator">
  <h3>Users currently on this page:</h3>
  <ul>
    <li *ngFor="let user of usersOnThisPage">
      {{ user.user.fullName }} - <span>tabs: {{user.tabs}}</span>
    </li>
  </ul>
  <p>Total users: {{ usersOnThisPage.length }}</p>
</div>
